import React,{useState,useEffect} from 'react'
import { Row, Col, Container } from "react-bootstrap"
import { makeStyles, useTheme,  withStyles, } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import CssBaseline from '@material-ui/core/CssBaseline';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import List from '@material-ui/core/List';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import InboxIcon from '@material-ui/icons/MoveToInbox';
import MailIcon from '@material-ui/icons/Mail';
//import DashboardIcon from '@material-ui/icons/Dashboard';
//import PaymentIcon from '@material-ui/icons/Payment';
//import ReceiptIcon from '@material-ui/icons/Receipt';

import PersonPinIcon from '@material-ui/icons/PersonPin';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import Grid from '@material-ui/core/Grid';
import FormControl from '@material-ui/core/FormControl';
import { InputGroup, InputGroupAddon, Input } from 'reactstrap';
import InputLabel from '@material-ui/core/InputLabel';
import {TextField, Select} from '@material-ui/core';
import { UncontrolledCollapse,Form, Collapse, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { ButtonToggle } from "reactstrap";
import {Accordion,Button,DropdownButton,ButtonGroup,Dropdown,Modal} from "react-bootstrap"
import { Link , Redirect} from 'react-router-dom';
import {toast , ToastContainer} from "react-toastify"
import { Tooltip } from 'reactstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'typeface-roboto';
import CreditCardInput from 'react-credit-card-input';
import "../App.css"
import Axios from 'axios';
import { base_url } from '../globalConstants';
import { useHistory } from 'react-router-dom';


const cancel={
    color:"darkblue",
    paddingRight: "27px",
    paddingLeft: "27px",
    paddingTop: "15px",
    paddingBottom: "17px",
    borderRadius:"25px",
    border:"none",
    float:"right",
    
  }

  const buttonstyle={
    color:"darkblue",
    backgroundColor:"skyblue",
    paddingRight: "27px",
    paddingLeft: "27px",
    paddingTop: "15px",
    paddingBottom: "17px",
    textAlign: "center",
    textDecoration: "none",
    borderRadius:"25px",
    border: "3px solid",
    float:"right",
    
  }


function MyVerticallyCenteredModal(props) {
    return (
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Card Authorization
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h4>Status</h4>
          {
            props.isCardUpdated
            ?<h5>Card Authorization Successfull</h5>
            :<h5>Card Update and Authorization Successfull</h5>
          }          
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={props.onHide}>OK</Button>
        </Modal.Footer>
      </Modal>
    );
  }


export default function Payment() {
    const [modalShow, setModalShow] = React.useState(false);
   
    const [isOpen1, setIsOpen1] = useState(false);
  
   
    const toggle1 = () => setIsOpen1(!isOpen1);
    const [tooltipOpen, setTooltipOpen] = useState(false);
    const [tooltipOpenExpire, setTooltipOpenExpire] = useState(false);
    const [tooltipOpenCvv, setTooltipOpenCvv] = useState(false);
    const [tooltipOpenZipcode, setTooltipOpenZipcode] = useState(false);


    const [username,setusername]=useState('')
    const [validated,setValidated]=useState(false);
    const [EzzId,setEzzId]=useState('')

    const [CardNumber, setCardNumber]=useState(' ');
    const [ExpiryMonth,setExpiryMonth]=useState(' ');
    const [ExpiryYear ,setExpiryYear]=useState(' ');
    const [CVV ,setCVV]=useState(' ');
    const [monthList, setMonthList]=useState([])
    const [yearList, setYearList]=useState([])
    const [isCardAdded, setIsCardAdded]=useState(false)
    const [currCardNumber, setCurrCardNumber]=useState('')
    const [currCardType, setCurrCardType]=useState('')
    const [currCardExpiry, setCurrCardExpiry]=useState('')
    const [errorCard, setErrorCard] = useState('')
    const [isCardUpdated, setIsCardUpdated] = useState(false)
    const [isAddress, setIsAddress] = useState(false)
    
    // console.log("tempMonth",tempMonth);
  

  const toggle2 = () => setTooltipOpen(!tooltipOpen);
  const toggleexpire = () => setTooltipOpenExpire(!tooltipOpenExpire);
  const toggleCvv = () => setTooltipOpenCvv(!tooltipOpenCvv);
  const togglezipcode = () => setTooltipOpenZipcode(!tooltipOpenZipcode);
const history = useHistory();
  const fetchUserCardDetails = async () => {

    // const { data } = await Axios.post(base_url+`customer_card_info/`)

    var ezz_id = localStorage.getItem('ezzyid')
    
    await Axios({
      method: 'POST',
      url: base_url+`customer_card_info`,
      data: {"ezz_id": ezz_id},
      headers: {'Content-Type': 'application/json' }
    })
    .then(function (response) {
      //handle success
        console.log(response.data);   
        setCurrCardNumber(response.data.Card_number)
        setCurrCardType(response.data.Card_type)
        setCurrCardExpiry(response.data.Expiry_date)
        setIsCardAdded(true)    
  
      })
      .catch(function (response) {
          //handle error
          console.log(response);
          // toast.warn('Some Error! Please try again');
      });
    
}

const onHome = async () => {
		history.push('/customerdashboard');
	}
	
  function setFunExpiryMonth(mont)
  {
    if (mont.length > 2)
    { 
      document.getElementById('cardMonth').value = mont.substring(0, 2);
    }
    setExpiryMonth(document.getElementById('cardMonth').value);
  }

  function setFunExpiryYear(mont)
  {
    if (mont.length > 4)
    { 
      document.getElementById('cardYear').value = mont.substring(0, 4);
    }
    setExpiryYear (document.getElementById('cardYear').value);
  }

  const handleUpdateCard = async () => {

    console.log(EzzId);
    console.log(CardNumber);
    // console.log(`EXPIRYYYYYYY:::::20${ExpiryYear}-${ExpiryMonth}`);                     //WHEN YY
    console.log(`EXPIRYYYYYYY:::::${ExpiryYear}-${ExpiryMonth}`);                        //WHEN YYYY
    console.log("cvv", CVV);

   await Axios({
        method:"post",
        url: base_url+"update_card_details",
        data: {
            "ezz_id": EzzId,
            "card_number": CardNumber,
            "expiry_date": ExpiryYear+"-"+ExpiryMonth,
            "cvv": CVV
        }
    }).then(function(response){
        console.log(response);


        setIsCardUpdated(true)
        setModalShow(true)
        // returning same profile id and payment profile id
        //  Axios({
        //     method: "post",
        //     url: base_url+"authorize_credit_card",
        //     data:{
        //         "ezz_id": EzzId
        //     }
        
        // }).then(function(response){
        //   setModalShow(true);
        //     console.log(response);
        // }).catch(function(response){
        //     console.error(response);
        // })

    }).catch(function(response){
        console.log(response);
        toast.error(response.error);
        toast.error(response.description);
        toast.error('INVALID DETAILS');
        var errorMsg1 = response.error
        var errorMsg2 = response.description
        var errorMsg = errorMsg1 + errorMsg2
        console.log('errorMsg',errorMsg);
        // setErrorCard(errorMsg)
        // setErrorCard('INVALID DETAILS')
        
    })

  }

  const checkUserAddress = () => {

    Axios({
      method: 'get',
      url: base_url+`customers/${localStorage.getItem('ezzyid')}/`,
      headers: { 'Content-Type': 'application/json' }
    }).then(function(response){
      console.log(response)
      console.log(response.data)

      const userDetails =  response.data

      setIsAddress(response.data.state)

    }).catch(function(response){
      console.log(response);
    })  

  }  

  useEffect(()=>{

    setusername(localStorage.getItem('username'));
    setValidated(localStorage.getItem('validated'));
    setEzzId(localStorage.getItem('ezzyid'));
    var temp_month = []
    for(var i=1; i<=12; i++ )
      temp_month.push(i)
    setMonthList(temp_month)

    var temp_year = []
    var curr_year = (new Date()).getFullYear()
    for(var i=0; i<10; i++){
      var new_year = (curr_year+i).toString()
      // new_year = new_year.substring(2)
      temp_year.push(new_year)
    }
      
      
    console.log('temp_year',temp_year);  
    setYearList(temp_year)

    fetchUserCardDetails()
    checkUserAddress()
  
   },[])

    const handleFormSubmit=async (e)=>{
       e.preventDefault();
    
    console.log(EzzId);
    console.log(CardNumber);
    // console.log(`EXPIRYYYYYYY:::::20${ExpiryYear}-${ExpiryMonth}`);                     //WHEN YY
    console.log(`EXPIRYYYYYYY:::::${ExpiryYear}-${ExpiryMonth}`);                        //WHEN YYYY
    console.log("cvv", CVV);

    if (ExpiryYear.length < 4 || ExpiryMonth.length < 2)
    {
      alert("Please enter expiry month or year in correct format!");
      return;
    }

   await Axios({
        method:"post",
        url: base_url+"create_payment_id ",
        data: {
            "ezz_id": EzzId,
            "card_number": CardNumber,
            "expiry_date": ExpiryYear+"-"+ExpiryMonth,
            "cvv": CVV
        }
    }).then(function(response){
        console.log(response);

         Axios({
            method: "post",
            url: base_url+"authorize_credit_card",
            data:{
                "ezz_id": EzzId
            }
        
        }).then(function(response){
          console.log(response);
            setModalShow(true);
            console.log(isCardUpdated);
        }).catch(function(response){
            console.error(response);
        })

    }).catch(function(response){
        console.log(response);
        toast.error('Error. Please enter your details');
        
    })
   }

    return (
      <div>
        <Grid container spacing={3}>
          <Grid item xs={6} sm={6}>
			  {/* <h3 style={{ marginLeft: '10px' }} id="paymentreminder">Payment Authorization</h3> */}
			  <br/><br/>
			<h2 className="general-heading">Payment Authorization</h2>
          </Grid>

          <Grid item xs={6}>
           
          </Grid>
        </Grid><br/>

        <Container>
          <Row>
            <Col>
            <Form>
            <Row>
              <Col>
                <h4>Enter Card Details</h4>
              </Col>
              <Col>
                <h4 style={{ color: 'red' }} >{ errorCard }</h4>                
              </Col>
            </Row>
            <Row>
              <Col  lg={{ span: 12 }} >
              <h5 style={{color:"grey"}}> Card Number</h5> 
                <InputGroup size="lg" >
                  <TextField  required id="outlined-required" label="Card Number" onChange={(e) => setCardNumber(e.target.value)} type="number"                  
                  placeholder="Enter your Card Number" variant="outlined" fullWidth />
                  {/* <Input placeholder="Enter your Card Number" onChange={(e) => setCardNumber(e.target.value)} type="number" style={{ borderRadius: "3px", borderColor: "#58585f" }} /> */}
                </InputGroup>
              </Col>
            </Row><br/>
            <Row>
              <Col lg={{ span: 6 }}>
                <h5 style={{color:"grey"}}>Expiration Date</h5>  
                <Row>
                                    <Col lg={{ span: 6 }}>
                    {/*FormControl variant="outlined" fullWidth>
                      <InputLabel id="cardMonth-label">Month</InputLabel>
                      <Select required
                        labelId="cardMonth-label"
                        id="cardMonth"
                        onChange={(e) => setExpiryMonth(e.target.value)}
                        label="Month"
                      >
                        {/* <option aria-label="None" value="" /> */}
                        {/*{
                          monthList.map((key,index) => {
                              if(key<10)
                                return <option key={index} value={`0${key}`} >0{key}</option>
                              else
                                return <option key={index} value={key}>{key}</option>
                          })
                        }*/}
                       
                      {/*</Select>
                    </FormControl>*/}
                    {/* <Select
                      labelId="Month"
                      id="cardMonth"
                      type="number"
                      // value={age}
                      // onChange={(e) => setExpiryMonth(e.target.value)}
                    >
                      <option aria-label="None" value="" />
                      <option aria-label="None" value="okayy" /> */}
                          {/* {
                            ()=>{
                              for (var i = 1; i <=12; i++)
                                return <option value={i}>{i}</option> 
                            }                                                       
                          } */}
                          {/* {Details.map(key => {
                            return (
                              <option>{key.name}</option>
                            )
                          })} */}
                      {/* <MenuItem value="">
                        <em>None</em>
                      </MenuItem>
                      <MenuItem value={10}>Ten</MenuItem>
                      <MenuItem value={20}>Twenty</MenuItem>
                      <MenuItem value={30}>Thirty</MenuItem> */}
                    {/* </Select> */}
                     <TextField required id="cardMonth" label="Month" onChange={(e) => setFunExpiryMonth(e.target.value)} type="number"
                      placeholder="MM" variant="outlined"  fullWidth
                      InputProps={{
                        inputProps: { 
                          max: 12, min: 1 , maxlength: 2 
                      }
                    }}/>
                  </Col>
                  <Col lg={{ span: 6 }}>

                    {/* <FormControl variant="outlined" fullWidth>
                      <InputLabel id="cardYear-label">Year</InputLabel>
                      <Select required
                        labelId="cardYear-label"
                        id="cardYear"
                        onChange={(e) => setExpiryYear(e.target.value)}
                        label="Year"
                      >
                        {/* <option aria-label="None" value="" /> */}
                        {/*{
                          yearList.map(key => {
                              return <option value={key}>{key}</option>
                          })    
                        }
                       </Select>
                    </FormControl>*/}

                    <TextField required id="cardYear" label="Year" onChange={(e) => setFunExpiryYear(e.target.value)} type="number"
                      placeholder="YYYY" variant="outlined"  fullWidth
                      InputProps={{
                        inputProps: { 
                          max: 2022, min: 2050 
                      }
                    }}/>   
                  </Col>

                </Row>                                                     
              </Col>                
                    
              {/* <Col lg={{ span: 3 }}>
              <h5 style={{color:"grey"}}>Expiration Date</h5> 
                  <InputGroup size="lg">
                    <Input type="text" placeholder="MM" onChange={(e) => setExpiryMonth(e.target.value)} 
                    style={{ borderColor: "#58585f", borderRadius: "3px" }}  />
                    <Input type="text" placeholder="YY" onChange={(e) => setExpiryYear(e.target.value)} 
                    style={{ borderColor: "#58585f", borderRadius: "3px" }}  />
                  </InputGroup>
              </Col> */}
              <Col lg={{ span: 6 }}>
                <h5 style={{color:"grey"}}>CVV</h5> 
                <TextField required id="cardCvv" placeholder="CVV" label="CVV" variant="outlined" 
                  onChange={(e) => setCVV(e.target.value)} type="number" fullWidth />  
                {/* <InputGroup size="lg" >
                  <Input placeholder="CVV" type="text" onChange={(e) => setCVV(e.target.value)}
                  style={{ borderColor: "#58585f", borderRadius: "3px" }}  />
                </InputGroup> */}
              </Col>
            </Row><br/>
            <Row>
              <Col lg={{ span: 12 }} >
                <h5 style={{ color: "grey" }}>Card Holder Name</h5>
                <TextField id="cardHolder" placeholder="Card Holder Name" label="Name" variant="outlined" fullWidth /> 
                {/* <InputGroup size="lg" >
                  <Input style={{ borderRadius: "3px", borderColor: "#58585f" }} />
                </InputGroup> */}
              </Col>
            </Row><br/>
            <Row>
              <Col  lg={{ span: 4, offset: 4 }}  >
                <Button variant='primary' size='lg' block onClick= { onHome  }>Home</Button>                            
              </Col>  {' '}
              <Col lg={{ span: 4 }}  >
                {
                  isCardAdded
                  ?<Button variant='info' onClick={(e)=>handleUpdateCard(e)} size='lg' block>Update</Button>
                  :<Button variant='info' onClick={(e)=>handleFormSubmit(e)} size='lg' block>Authorize</Button>
                }
                
                
              </Col>
              <MyVerticallyCenteredModal
                show={modalShow}
                onHide={() => setModalShow(false)} />          
            </Row>
          </Form>   
            </Col>
            <Col lg={{ span: 4, offset: 2}} >
                {
                  isCardAdded
                  ?
                    <>
                      <h3>Current Card</h3>
                      <tbody>
                        <tr >
                          <th scope="row">Card Number</th>
                          <td  >:</td>
                          <td>{ currCardNumber }</td>
                        </tr>
                        <tr >
                          <th >Card Type</th>
                          <td>:</td>
                          <td>{ currCardType }</td>
                        </tr>
                        <tr >
                          <th >Card Expiry</th>
                          <td>:</td>
                          <td>{ currCardExpiry }</td>
                        </tr>
                      </tbody>  
                    </>  
                  :""

                }
                {
                  isCardUpdated
                  ?<span style={{ color: 'green' }}>Card Updated Successfully.</span>
                  :""
                }
            </Col>
          </Row>

       
        </Container>

        {/* <Grid container spacing={3}>
        <Grid item xs={12}>
        <h4>Saved cards goes below</h4>
        </Grid>
        </Grid>
        <Grid container spacing={1}>
        <Grid item xs={12}>
        <h4 style={{color:"grey"}}>Card holder's name</h4>
        </Grid>
        <Form>
        <Grid container spacing={6}>
        <Grid item xs={6} sm={3}>
        <InputGroup size="lg" style={{width:"200%"}}>
        
        <Input style={{borderRadius:"10px",borderColor:"grey"}} />
      </InputGroup>
      </Grid>
      </Grid> 
      <Grid container spacing={4}>
      <Grid item xs={12}>
      <h4 style={{color:"grey"}}> Card number</h4> 
      </Grid>
      </Grid> 
      <Grid container spacing={9}>
      <Grid item xs={6} sm={7}>
      <InputGroup size="lg"> 
      
      <Input placeholder="Enter your Card Number" onChange={(e)=>setCardNumber(e.target.value)} type="number" style={{borderRadius:"10px",borderColor:"grey"}} />
      <InputGroupAddon addonType="append"> <HelpOutlineIcon id="TooltipExample" style={{color:"#4C4B4B",width:"50px",height:"50px"}}/></InputGroupAddon>
    </InputGroup>

    <Tooltip placement="right" isOpen={tooltipOpen} target="TooltipExample" toggle={toggle2}>
    Insert Your Debit/Credit card Number which displays on top of your card!!
  </Tooltip>
      </Grid>
      </Grid> 

      <Grid container spacing={6} style={{color:"grey"}}>
      <Grid item xs={6} sm={4}>
     <h4>Expiration</h4> 
      </Grid>
      <Grid item xs={6} sm={4}>
     <h4>CVV</h4>
      </Grid>
      <Grid item xs={6} sm={4}>
      <h4>zip Code</h4>
    </Grid> 
      
      </Grid>

      <Grid container spacing={4}>
      <Grid item xs={7} sm={4}>
      <InputGroup style={{width:"140px", borderColor:"black", borderRadius:"10px"}}  size="lg">
     
      <Input type="text" placeholder="yyyy-mm" onChange={(e)=>setExpire(e.target.value)} />

      <InputGroupAddon addonType="append"> <HelpOutlineIcon id="TooltipExampleexpire" style={{color:"#4C4B4B",width:"50px",height:"50px"}}/></InputGroupAddon>
    </InputGroup>
    <Tooltip placement="right" isOpen={tooltipOpenExpire} target="TooltipExampleexpire" toggle={toggleexpire}>
    Enter the Expiration Month/Year of Your debit/credit card.
  </Tooltip>
    
      </Grid>
      <Grid item xs={6} sm={4}>
      <InputGroup size="lg" style={{width:"140px"}}> 
      
      <Input placeholder="CVV" type="text"/>
      <InputGroupAddon addonType="append"> <HelpOutlineIcon id="TooltipExampleCvv" style={{color:"#4C4B4B",width:"50px",height:"50px"}}/></InputGroupAddon>
    </InputGroup>
    <Tooltip placement="right" isOpen={tooltipOpenCvv} target="TooltipExampleCvv" toggle={toggleCvv}>
    Flip your card back and you may find 3 digit CVV code. Don't share it with anyone else.
  </Tooltip>
      </Grid>
      <Grid item xs={5} sm={4}>
      <InputGroup size="lg">
     
      <Input type="number" />
      <InputGroupAddon addonType="append"> <HelpOutlineIcon id="TooltipExampleZipcode" style={{color:"#4C4B4B",width:"50px",height:"50px"}}/></InputGroupAddon>
    </InputGroup>
    <Tooltip placement="right" isOpen={tooltipOpenZipcode} target="TooltipExampleZipcode" toggle={togglezipcode}>
    Please enter your Zip code for your city/district.
  </Tooltip>
  </Grid> 
  
      </Grid>
<br/>
      <div className="footer">
          <Button onClick={(e)=>handleFormSubmit(e)} style={buttonstyle}>Authorize</Button>
          <Button style={cancel}>Cancel</Button>
          
          </div>
          <MyVerticallyCenteredModal
          show={modalShow}
          onHide={() => setModalShow(false)}
        />
         

        
        </Form>
          
        </Grid> */}
       <ToastContainer/>
        </div>
    )
}
